import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'

export type Language = 'th' | 'en'

export const useLanguageStore = defineStore('settings/language', () => {
  // State
  const language = useLocalStorage<Language>('settings/language/language', 'th')
  const languages: Language[] = ['th', 'en']

  // Getters
  const currentLanguage = computed(() => language.value)
  const availableLanguages = computed(() => languages)

  // Actions
  const switchLanguage = (lang?: Language) => {
    if (lang) {
      if (languages.includes(lang)) {
        language.value = lang
      } else {
        console.warn(`Language "${lang}" is not supported.`)
      }
    } else {
      const currentIndex = languages.indexOf(language.value)
      const nextIndex = (currentIndex + 1) % languages.length
      language.value = languages[nextIndex]
    }
  }

  return {
    language,
    currentLanguage,
    availableLanguages,
    switchLanguage,
  }
})
